import i18n from "../../../../../../constants/i18n";
import Et3Image from "../../../../../../core/et3-Image";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";
import getKhattabatMediaStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-media-store";
const UploadImage = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { conversationID } = props;
  const shouldShow = !getCorePersonalStore().isKhattabaAiAdmin.get();

  return !shouldShow ? null : (
    <ET3Div
      width={30}
      height={40}
      alignItems={"center"}
      fDirection={"column"}
      justifyContent={"center"}
      style={{}}
      color={""}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => getKhattabatMediaStore(conversationID).handleImageUpload()}
    >
      <Et3Image
        type="LOCAL"
        alt={i18n.get("USER")}
        imageName={"khattabat-image-logo"}
        size={25}
        onClick={() => {}}
        style={{ cursor: "pointer" }}
      />
    </ET3Div>
  );
});

export default UploadImage;
